module.exports = __webpack_public_path__ + "img/help_address_pl.37c8bfec.png";